const baseUrl = process.env.REACT_APP_BASE_URL || 'https://mv-profile-959685280830.asia-south1.run.app';

export const EnvironmentManager = {
  baseUrl,
  endpoints: {
    
    saveUserDetails: "/mv-profile/profile-user-details/save-user-details",
    updateUserDetails: "/mv-profile/profile-user-details/update-user-details",
    getUserDetails: "/mv-profile/profile-user-details/get-user-details",
    deleteUserDetails: "/mv-profile/profile-user-details/delete-user-details",

    // User Profile Image Endpoints
    uploadProfileImage: "/mv-profile/user-profile-image/upload",
    getProfileImage: "/mv-profile/user-profile-image",
    updateProfileImage: "/mv-profile/user-profile-image/update",
    deleteProfileImage: "/mv-profile/user-profile-image",

    saveResumeDocument: "/mv-profile/profile-resume-document/save-profile-resume-document",
    updateResumeDocument: "/mv-profile/profile-resume-document/update-profile-resume-document",
    getResumeDocument: "/mv-profile/profile-resume-document/get-profile-resume-document",
    deleteResumeDocument: "/mv-profile/profile-resume-document/delete-profile-resume-document",

    saveUserAddress: "/mv-profile/profile-user-address/save-user-address",
    getUserAddress: "/mv-profile/profile-user-address/get-user-address",
    updateUserAddress: "/mv-profile/profile-user-address/update-user-address", 
    deleteUserAddress: "/mv-profile/profile-user-address/delete-user-address",

    saveUserSkills:
 "/mv-profile/profile-user-skills/save-user-skills",

 getUserSkills:
 "/mv-profile/profile-user-skills/get-user-skills",

 updateUserSkills:
 "/mv-profile/profile-user-skills/update-user-skills",

 deleteUserSkills:
 "/mv-profile/profile-user-skills/delete-user-skills",

    uploadCourseDetails: "/mv-profile/audio-courses/upload-course-details",
    updateCourseDetails: "/mv-profile/audio-courses/update-course-details",
    getCourseDetailsByUser: "/mv-profile/audio-courses/get-course-details/by-user",
    deleteCourseDetails: "/mv-profile/audio-courses/delete-course-details",
    archiveCourse: "/mv-profile/audio-courses/archive-course",
    unarchiveCourse: "/mv-profile/audio-courses/unarchive-course",

    // Draft Audio Course endpoints
    saveDraft: "/mv-profile/audio-courses/save-draft",
    getDraftCourses: "/mv-profile/audio-courses/draft-courses",
    getDraftCourse: "/mv-profile/audio-courses/draft-course",
    publishDraft: "/mv-profile/audio-courses/publish-draft",

    textToSpeech: "/mv-profile/convert/text-to-speech",
    streamAudio: "/mv-profile/convert/stream-audio",
    getAvailableVoices: "/mv-profile/convert/available-voices",

    // Video Courses API
    uploadVideoCourseDetails: "/mv-profile/video-courses/upload-course-details",
    getVideoCourseDetailsByUser: "/mv-profile/video-courses/get-course-details/by-user",
    updateVideoCourseDetails: "/mv-profile/video-courses/update-course-details", 
    deleteVideoCourseDetails: "/mv-profile/video-courses/delete-course-details", 
    archiveVideoCourse: "/mv-profile/video-courses/archive-course", 
    unarchiveVideoCourse: "/mv-profile/video-courses/unarchive-course",
   
    updateVideoCourseExcel: "/mv-profile/video-courses/update-course-excel",
    updateVideoCourseVideos: "/mv-profile/video-courses/update-course-videos",
    getCourseWithExcel: "/mv-profile/video-courses/course-with-excel",

    // Draft Video Course endpoints
    saveVideoDraft: "/mv-profile/video-courses/save-draft",
    getDraftVideoCourses: "/mv-profile/video-courses/draft-courses",
    getDraftVideoCourse: "/mv-profile/video-courses/draft-course",
    publishVideoDraft: "/mv-profile/video-courses/publish-draft",

    
    getVideoProgress: "/mv-profile/video-courses/progress",
    saveVideoProgress: "/mv-profile/video-courses/progress",

    // Random Courses API
    getRandomDetailedCourses: "/mv-profile/audio-courses/random-detailed",

     // File download endpoint
    downloadFile: "/mv-profile/files/download",

    // Search API endpoint
    searchCourses: "/mv-profile/audio-courses/search",

    // Watch History API endpoints
    saveWatchHistory: "/mv-profile/audio-courses/watch-history",
    getWatchHistory: "/mv-profile/audio-courses/watch-history",
    getWatchHistoryCourse: "/mv-profile/audio-courses/watch-history",

    //video course search
searchVideoCourses: "/mv-profile/search-courses",

    //video courses random
getRandomVideoCourses: "/mv-profile/video-courses/random-detailed",

    // Video Course Watch History API endpoints
    saveVideoWatchHistory: "/mv-profile/video-courses/watch-history",
    getVideoWatchHistory: "/mv-profile/video-courses/watch-history",
    getVideoWatchHistoryCourse: "/mv-profile/video-courses/watch-history",

    // Archived Courses API endpoints (dedicated endpoints, not client-side filtered)
    getArchivedAudioCourses: "/mv-profile/audio-courses/archived-courses",
    getArchivedAudioCourse:  "/mv-profile/audio-courses/archived-course",
    getArchivedVideoCourses: "/mv-profile/video-courses/archived-courses",
    getArchivedVideoCourse:  "/mv-profile/video-courses/archived-course",

// COMPANY DETAILS endpoints
    createCompany: "/mv-profile/companies/upload-company-details",
    updateCompany: "/mv-profile/companies/update-company-details",
    getCompany: "/mv-profile/companies/get-company-details",
    deleteCompany: "/mv-profile/companies/delete-company-details",
    
    // COMPANY ADDRESS endpoints
    createCompanyAddress: "/mv-profile/companies/upload-company-address",
    updateCompanyAddress: "/mv-profile/companies/update-company-address",
    getCompanyAddress: "/mv-profile/companies/get-company-address",
    deleteCompanyAddress: "/mv-profile/companies/delete-company-address",
    
    // COMPANY ADMIN endpoints
    createCompanyAdmin: "/mv-profile/companies/upload-admins-details",
    updateCompanyAdmin: "/mv-profile/companies/update-admins-details",
    getCompanyAdmins: "/mv-profile/companies/get-admins-details",
    deleteCompanyAdmin: "/mv-profile/companies/delete-admins-details",
    
    // COMPANY DOCUMENT endpoints
    uploadCompanyDocument: "/mv-profile/companies/upload-company-documents",
    updateCompanyDocument: "/mv-profile/companies/update-company-documents",
    getCompanyDocuments: "/mv-profile/companies/get-company-documents",
    deleteCompanyDocument: "/mv-profile/companies/delete-company-documents",
    
    // Full Company Details
    getFullCompanyDetails: "/mv-profile/companies/get-full-company-details",
softDeleteCompany: "/mv-profile/companies/delete-full-company-details" ,

// Hard Delete (from your existing code)
deleteCompany: "/mv-profile/companies/delete-company-details" ,

jobseekerJobSearch: "/mv-profile/jobs/search",

//saving jobs
    saveJob: "/mv-profile/saved-jobs/save",
    deleteSavedJob: "/mv-profile/saved-jobs/delete",
    getSavedJobByUser: "/mv-profile/saved-jobs/user",
    
    // recommended jobs
    recommendedJobs: "/mv-profile/recommended-jobs",


//company jobs
postJob: "/mv-profile/post-jobs",
    getJobPosted: "/mv-profile/get-job-posted",
    updateJobPost: "/mv-profile/update-job-post",
    deleteJobPost: "/mv-profile/delete-job-post",
    getAllJobPosted: "/mv-profile/get-all-job-posted",
    activateJob: "/mv-profile/activate-job",
    deactivateJob: "/mv-profile/deactivate-job",

  
    saveJob: "/mv-profile/saved-jobs/save",
    deleteSavedJob: "/mv-profile/saved-jobs/delete",
    getSavedJobByUser: "/mv-profile/saved-jobs/user",
    
    // recommended jobs
    recommendedJobs: "/mv-profile/recommended-jobs",

    // Job Application Endpoints
    createJobApplicationDraft: "/mv-profile/job-application/create-draft",
    saveJobApplicationBasicDetails: "/mv-profile/job-application/basic-details",
    uploadJobApplicationResume: "/mv-profile/job-application/resume",
    saveJobApplicationScreening: "/mv-profile/job-application/screening",
    getJobApplication: "/mv-profile/job-application",
    submitJobApplication: "/mv-profile/job-application/submit",

    // Job Application Status Endpoints
    getJobApplicationStatus: "/mv-profile/job-application/status",
    getUserApplications: "/mv-profile/job-application/user-applications",
    updateEmployerApplicationStatus: "/mv-profile/job-application",   // + /{id}/employer-status
    getJobApplicants: "/mv-profile/job-application/applicants/job",

    // Draft Application Endpoints
    getDraftApplications: "/mv-profile/job-application/drafts",
    getDraftApplicationById: "/mv-profile/job-application/draft",

    // Resdex — Recruiter Candidate Search
    recruiterCandidateSearch: "/mv-profile/recruiter/job-postings",

    // Candidate Search — Job Posting Search & Applicant Filter
    recruiterJobSearch: "/mv-profile/recruiter/job-postings/search-job-posting",
    recruiterApplicantFilter: "/mv-profile/recruiter/job-postings/search-candidate",

    // Profile Skill Video Endpoints
    saveSkillVideo: "/mv-profile/profile-user-skill-video/save-profile-skill-video",
    getSkillVideo: "/mv-profile/profile-user-skill-video/get-profile-skill-video",
    updateSkillVideo: "/mv-profile/profile-user-skill-video/update-profile-skill-video",
    deleteSkillVideo: "/mv-profile/profile-user-skill-video/delete-profile-skill-video",

    // Course Creator Role
    becomeCreator: "/roles/become-creator",

    // Subscription & Payment endpoints
    getPlans:                "/mv-profile/subscription/get-plans",
    createPurchase:          "/mv-profile/subscription/create-purchase",
    getPurchase:             "/mv-profile/subscription/get-purchase",
    createOrder:             "/mv-profile/subscription/create-order",
    verifyPayment:           "/mv-profile/subscription/verify-payment",
    getUserPurchases:        "/mv-profile/subscription/get-user-purchases",
    getActiveSubscription:   "/mv-profile/subscription/get-active-subscription",

    // Invoice endpoints
    getInvoiceByCheckout:    "/mv-profile/invoice/by-checkout",
    getInvoiceByPurchase:    "/mv-profile/invoice/by-purchase",
    getInvoicesByUser:       "/mv-profile/invoice/by-user",
    getInvoiceById:          "/mv-profile/invoice",
    viewInvoicePdf:          "/mv-profile/invoice",
    downloadInvoicePdf:      "/mv-profile/invoice",

    // Contact Us endpoints (user-facing)
    contactUsGet:                "/mv-profile/contact-us",
    contactUsSendMessage:        "/mv-profile/contact-us/message",
    contactUsFaqs:               "/mv-profile/contact-us/faqs",

    // Contact Us endpoints (admin)
    contactUsAdminSave:          "/mv-profile/contact-us/admin",
    contactUsAdminMessages:      "/mv-profile/contact-us/admin/messages",
    contactUsAdminMessage:       "/mv-profile/contact-us/admin/message",
    contactUsAdminFaqs:          "/mv-profile/contact-us/admin/faqs",

    // Course Creator Terms & Conditions endpoints
    getCourseCreatorTerms:       "/mv-profile/course-creator/terms",
    createCourseCreatorTerms:    "/mv-profile/course-creator/admin/terms",
    getAllCourseCreatorTerms:     "/mv-profile/course-creator/admin/terms",

    // Cart Endpoints
    cartAdd:                     "/mv-profile/cart/add",
    cartGet:                     "/mv-profile/cart",
    cartRemove:                  "/mv-profile/cart/remove",
    cartClear:                   "/mv-profile/cart/clear",
    cartCreateCheckout:          "/mv-profile/cart/create-checkout",
    cartCreateOrder:             "/mv-profile/cart/create-order",
    cartVerifyPayment:           "/mv-profile/cart/verify-payment",

    // Refund Policy endpoints
    refundPolicyAdmin:           "/mv-profile/refund-policy/admin",
    refundPolicyAdminAll:        "/mv-profile/refund-policy/admin/all",
    refundPolicyActive:          "/mv-profile/refund-policy/active",
    refundPolicyAccept:          "/mv-profile/refund-policy/accept",
  },
  config: {
    requestTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 60000,
    maxUploadSize: parseInt(process.env.REACT_APP_MAX_UPLOAD_SIZE) || 10 * 1024 * 1024,
    maxRetries: parseInt(process.env.REACT_APP_MAX_RETRIES) || 3,
    retryDelay: parseInt(process.env.REACT_APP_RETRY_DELAY) || 1000,
  },
};

export const buildUrl = (endpoint, id = null) => {
  let url = `${EnvironmentManager.baseUrl}${endpoint}`;
  if (id) {
    url += `/${id}`;
  }
  return url;
};

export default EnvironmentManager;